import { EbookDownload } from "./EbookDownload";
import { ResourcesGrid } from "./resources/ResourcesGrid";

export const ResourcesSection = () => {
  return (
    <section id="resources" className="py-24 bg-gradient-to-b from-white to-spirit-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="inline-block px-3 py-1 text-sm font-medium bg-spirit-100 text-spirit-700 rounded-full">
            Resources
          </span>
          <h2 className="mt-4 text-4xl font-serif font-medium text-gray-900">
            Explore & Learn
          </h2>
          <p className="mt-4 text-xl text-gray-600 max-w-2xl mx-auto">
            Discover valuable resources to help you understand and navigate your
            twin flame journey.
          </p>
        </div>
        
        <ResourcesGrid />
        
        <div className="mt-16 bg-spirit-50 rounded-2xl p-8">
          <div className="text-center max-w-2xl mx-auto">
            <h3 className="text-2xl font-medium text-gray-900 mb-4">
              Get Your Free Twin Flame Guide
            </h3>
            <p className="text-gray-600 mb-6">
              Download our comprehensive guide to understanding and navigating your twin flame journey.
            </p>
            <EbookDownload source="resources_section" variant="secondary" />
          </div>
        </div>
      </div>
    </section>
  );
};